<template>
  <div>
    <div class="facebook-card">
      <skeleton-loader-vue
        type="ract"
        :width="200"
        :height="20"
        animation="wave"
      />
    </div>
  </div>
</template>

<script>
import SkeletonLoaderVue from "skeleton-loader-vue"

export default {
  name: "TextShimmer",
  components: {
    SkeletonLoaderVue,
  },
}
</script>

<style>
</style>